import Link from "next/link";
import { useTranslation } from "react-i18next";
import Separator from "@/my_components/Common/Separator";

import { ROUTE } from "@/route/app_routes.js";


const CopyRight = () => {

  const year = new Date().getFullYear()
  const { t } = useTranslation();

  return (

    <>

      <Separator />

      <div className="copyright-area copyright-style-1 ptb--20">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-12">
              <p className="rbt-link-hover text-center text-lg-start">
                {t("footer.copyright")}{" "}{year}{" "}
                <Link href="https://smarttechacademy.org/">
                  {t("footer.logoAlt")}.
                </Link>{" "}
                {t("footer.allRightsReserved")}
              </p>
            </div>
            <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-12">
              <ul className="copyright-link rbt-link-hover justify-content-center justify-content-lg-end mt_sm--10 mt_md--10">
                <li><Link href={ ROUTE.terms }>{t("footer.termsOfService")}</Link></li>
                <li><Link href={ ROUTE.privacy }>{t("footer.links.privacyPolicy")}</Link></li>
                <li><Link href={ ROUTE.Faq }>{t("footer.links.faq")}</Link></li>
              </ul>
            </div>
          </div>
        </div>
      </div>

    </>

  );

};

export default CopyRight;
